import { Button, Form, Input, Radio, Typography } from 'antd';
import React, { useState, useEffect } from 'react';
import LilyButton from '../../../../../components/button/lily-button';
import { useClaimContext } from '../../component/claim-context';
import UploadFile from '../../../../../components/upload/upload-file';

const InsuranceCard = (props) => {
    const [form] = Form.useForm();
    const { caseType, setCurrentType } = props;
    const { Title, Text } = Typography;
    const [isUploading, setIsUploading] = useState(false);
    const [isNext, setIsNext] = useState(false);

    const {
        claimForm,
        setClaimForm,
        setSupportOptions,
    } = useClaimContext();

    const [disabledAction, setDisabledAction] = useState(true);

    const checkFieldsFilled = (sidesArray) => {
        const hasFrontAndBack = sidesArray.some(obj => obj.side === 'front') &&
            sidesArray.some(obj => obj.side === 'back');

        setDisabledAction(!hasFrontAndBack);
    };

    useEffect(() => {
        checkFieldsFilled(claimForm?.insuranceCards);
    }, [claimForm?.insuranceCards]);

    const handleSubmit = () => {
        setSupportOptions((prev) =>
            prev.map((item) =>
                item.value === caseType ? { ...item, checked: true } : item
            )
        );
        setCurrentType('');
    };

    return (
        <div className="d-flex flex-column gap-4">
            <Title className="mb-1 main-title" level={3}>
                Primary Insurance Card
            </Title>
            <Text>
                <span style={{ fontWeight: '700' }}>NEW</span> insurance card information:
            </Text>
            <div className='d-flex flex-column gap-3'>
                <div className='d-flex flex-column'>
                    <Title level={5}>Insurance Card Front</Title>
                    <UploadFile fieldKey="insuranceCards.front" uploadType="single" uploadedFiles={claimForm?.insuranceCards.find((item) => item.side === 'front')?.file ? [claimForm?.insuranceCards.find((item) => item.side === 'front')?.file] : []} setClaimForm={setClaimForm} setIsUploading={setIsUploading} setIsNext={setIsNext} />
                </div>
                <div className='d-flex flex-column'>
                    <Title level={5}>Insurance Card Back</Title>
                    <UploadFile fieldKey="insuranceCards.back" uploadType="single" uploadedFiles={claimForm?.insuranceCards.find((item) => item.side === 'back')?.file ? [claimForm?.insuranceCards.find((item) => item.side === 'back')?.file] : []} setClaimForm={setClaimForm} setIsUploading={setIsUploading} setIsNext={setIsNext} />
                </div>
            </div>
            <div className='d-flex flex-row justify-content-end mt-5'>
                <Button style={{ width: '200px' }} disabled={isUploading} color="default" variant="link" onClick={() => setCurrentType('')}>
                    Back
                </Button>
                <LilyButton style={{ width: '200px' }} onClick={handleSubmit} text="Next" disabled={disabledAction || isUploading || !isNext} />
            </div>
        </div>
    );
};

export default InsuranceCard;